export class SensorRecordsRequestModel {
  endPointId: string;
  sensorId: string;
  startDate: string;
  endDate: string;
  isViewByEndPoint: boolean;
  parameters: number[];
  sensorAssignmentId: string;
}

export class SampleRecordsAverageParameter {
  endPointId: string;
  endPointName: string;
  lat?: number;
  lon?: number;
  value?: number;
}
